export const changePassword = {
    "change_pwd_title": "cambiar la contraseña",
    "change_pwd_old_password": "Contraseña actual",
    "change_pwd_new_password": "Nueva contraseña",
    "change_pwd_confirm_password": "Confirmar contraseña",
    "change_pwd_error": "Error al cambiar la contraseña"
};
